import React from 'react';
import { AuthProvider } from '../../contexts/AuthContext';
import Navbar from './Navbar';

export default (props) => {
  return (
    <AuthProvider>
      <Navbar />
    </AuthProvider>
  );
};
